import { Directive, ElementRef, Renderer, Input, Output, EventEmitter, Inject, forwardRef, Optional } from "@angular/core";
import { animate, style, AnimationBuilder } from "@angular/animations";
import { AnimateScrollService } from './ng2-animate-scroll.service';
import { AnimateBoxDirective } from './ng2-animate-box.directive';
var AnimateScrollDirective = /** @class */ (function () {
    function AnimateScrollDirective(el, renderer, animateScrollService, animateBox, _builder) {
        var _this = this;
        this.el = el;
        this.renderer = renderer;
        this.animateScrollService = animateScrollService;
        this.animateBox = animateBox;
        this._builder = _builder;
        this.output = new EventEmitter();
        this.outputStats = new EventEmitter();
        this.classNameSetByAnimateScroll = '';
        //add listeneres for scroll and resize
        if (this.animateBox && this.animateBox.element) {
            this.renderer.listen(this.animateBox.element.nativeElement, 'scroll', function (evt) { _this._processEvent(); });
            this.renderer.listen(this.animateBox.element.nativeElement, 'resize', function (evt) { _this._processEvent(); });
        }
        else {
            this.renderer.listenGlobal('window', 'scroll', function (evt) { _this._processEvent(); });
            this.renderer.listenGlobal('window', 'resize', function (evt) { _this._processEvent(); });
        }
    }
    AnimateScrollDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this._processEvent();
        }, 0);
    };
    AnimateScrollDirective.prototype._processEvent = function () {
        if (!this.options || typeof (this.options) === 'string' || typeof (this.options) === 'number') {
            //no options or incorrect options provided -> proceed with default states
            console.warn('AnimateScroll:', 'Invalid options provided:', this.options);
        }
        else {
            if (typeof (this.options.states) === 'undefined' || !this.options.states.length) {
                this._applyDefaultStates();
            }
            else {
                var stateApplied = false;
                for (var i = 0; !stateApplied && i < this.options.states.length; i++) {
                    if (this._processState(this.options.states[i])) {
                        stateApplied = true;
                    }
                    ;
                }
                if (!stateApplied) {
                    //no state matched -> proceed with default states
                    this._applyDefaultStates();
                }
            }
        }
    };
    AnimateScrollDirective.prototype._applyDefaultStates = function () {
        var stateApplied = false;
        var defaultStates = this.animateScrollService.getDefaultStates();
        for (var i = 0; !stateApplied && i < defaultStates.length; i++) {
            if (this._processState(defaultStates[i])) {
                stateApplied = true;
            }
            ;
        }
        if (!stateApplied) {
            //no state matched at all
            console.warn('AnimateScroll:', 'No state matched current scroll position, please provide a default state!');
        }
    };
    AnimateScrollDirective.prototype._processState = function (state) {
        //check for valid values
        if (this._isValidState(state)) {
            //state is valid
            state = this._setValuesOrDefault(state);
            switch (state.method.toLowerCase()) {
                case 'pxleft':
                    return this._pxLeft(state);
                case 'percentLeft':
                    return this._percentLeft(state);
                case 'pxelement':
                    return this._pxElement(state);
                case 'percentelement':
                    return this._percentElement(state);
                case 'pxtotal':
                    return this._pxTotal(state);
                case 'percenttotal':
                    return this._percentTotal(state);
                case 'animatetopercent':
                    return this._animateToPercent(state);
                case 'animatefrompercent':
                    return this._animateFromPercent(state);
                case 'default':
                    return this._default(state);
                default:
                    console.warn('AnimateScroll:', 'Provided method doesn\'t match any possible methods: ', state.method);
                    return false;
            }
        }
        return false;
    };
    AnimateScrollDirective.prototype._setValuesOrDefault = function (state) {
        state.state = state.state || 'inactive';
        state.sizes = state.sizes || 'all';
        state.setAtLastChance = typeof (state.setAtLastChance) === 'boolean' ? state.setAtLastChance : true;
        state.setAtLastChanceTopPx = state.setAtLastChanceTopPx || 10;
        state.setAtLastChanceBottomPx = state.setAtLastChanceBottomPx || 10;
        return state;
    };
    AnimateScrollDirective.prototype._isValidState = function (state) {
        if (typeof (state.method) === 'undefined') {
            console.warn('AnimateScroll:', 'No method was provided for a state but is required.');
            return false;
        }
        if (typeof (state.method) !== 'string') {
            console.warn('AnimateScroll:', 'Invalid value for method:string provided : ', state.method);
            return false;
        }
        if (state.method !== 'default' && typeof (state.value) === 'undefined') {
            console.warn('AnimateScroll:', 'No value was provided for a state but is required if method isn\'t default.');
            return false;
        }
        if (state.method !== 'default' && typeof (state.value) !== 'number') {
            console.warn('AnimateScroll:', 'Invalid value for value:number provided : ', state.value);
            return false;
        }
        if (typeof (state.state) !== 'undefined' && typeof (state.state) !== 'string') {
            console.warn('AnimateScroll:', 'Invalid value for state:string provided : ', state.state);
            return false;
        }
        if (typeof (state.sizes) !== 'undefined' && typeof (state.sizes) !== 'string') {
            console.warn('AnimateScroll:', 'Invalid value for sizes:string provided : ', state.sizes);
            return false;
        }
        if (typeof (state.class) !== 'undefined' && typeof (state.class) !== 'string') {
            console.warn('AnimateScroll:', 'Invalid value for class:string provided : ', state.class);
            return false;
        }
        if (typeof (state.setAtLastChance) !== 'undefined' && typeof (state.setAtLastChance) !== 'boolean') {
            console.warn('AnimateScroll:', 'Invalid value setAtLastChance:boolean provided : ', state.sizes);
            return false;
        }
        return true;
    };
    AnimateScrollDirective.prototype._pxLeft = function (state) {
        //how much left before top of element is out of viewpoint in px
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            while (offsetElement) {
                elementOffsetTop += offsetElement.offsetTop;
                offsetElement = offsetElement.offsetParent;
            }
            var breakpoint = elementOffsetTop - state.value;
            return this._setElementState(scrollTop, breakpoint, state);
        }
        return false;
    };
    AnimateScrollDirective.prototype._percentLeft = function (state) {
        //how much left in percentage of window height before top of element reaches viewpoint
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.innerHeight : window.innerHeight);
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            while (offsetElement) {
                elementOffsetTop += offsetElement.offsetTop;
                offsetElement = offsetElement.offsetParent;
            }
            var pxLeftUntilTopViewpoint = elementOffsetTop - scrollTop;
            var percentageLeft = pxLeftUntilTopViewpoint / windowHeight * 100;
            var l_state = this._setElementState(state.value, percentageLeft, state);
            return l_state;
        }
        return false;
    };
    AnimateScrollDirective.prototype._buildParametricStyle = function (style, param) {
        var k_style = {};
        for (var l = 0; l < Object.keys(style).length; l++) {
            k_style[Object.keys(style)[l]] = style[Object.keys(style)[l]];
            if (typeof style[Object.keys(style)[l]] == 'number') {
                k_style[Object.keys(style)[l]] *= param ? param : 1;
            }
            if (typeof style[Object.keys(style)[l]] == 'object') {
                k_style[Object.keys(style)[l]] = this._buildParametricStyle(k_style[Object.keys(style)[l]], param);
            }
        }
        return k_style;
    };
    AnimateScrollDirective.prototype._animateToPercent = function (state) {
        // animate to percentage left of window height before top of element reaches top of animate box
        var l_state = false;
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.offsetHeight : window.innerHeight);
            var boxScrollHeight = (this.animateBox ? this.animateBox.element.nativeElement.scrollHeight : document.documentElement.scrollHeight);
            if (this.animateBox && parseInt(this.animateBox.element.nativeElement.style.paddingTop.replace('px', '')) > 0) {
                windowHeight = windowHeight - parseInt(this.animateBox.element.nativeElement.style.paddingTop.replace('px', ''));
            }
            if (this.animateBox && parseInt(this.animateBox.element.nativeElement.style.paddingBottom.replace('px', '')) > 0) {
                windowHeight = windowHeight - parseInt(this.animateBox.element.nativeElement.style.paddingBottom.replace('px', ''));
            }
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            var l_currentValue = this.options.currentValue;
            if (this.animateBox) {
                while (offsetElement != this.animateBox.element.nativeElement && offsetElement) {
                    elementOffsetTop += offsetElement.offsetTop;
                    offsetElement = offsetElement.offsetParent;
                }
            }
            else {
                while (offsetElement) {
                    elementOffsetTop += offsetElement.offsetTop;
                    offsetElement = offsetElement.offsetParent;
                }
            }
            var pxLeftUntilTopViewpoint = elementOffsetTop - scrollTop;
            var percentageLeft = (pxLeftUntilTopViewpoint > 0 && (pxLeftUntilTopViewpoint / windowHeight) * 100 > state.value) || (state.isLast && elementOffsetTop + nativeElement.scrollHeight < 0.99 * boxScrollHeight) ? (pxLeftUntilTopViewpoint / windowHeight) * 100 : 0;
            console.log(l_currentValue, state.value, windowHeight, scrollTop, pxLeftUntilTopViewpoint, percentageLeft, boxScrollHeight);
            l_state = this._setElementState(state.value, percentageLeft, state);
            if ((pxLeftUntilTopViewpoint / windowHeight) * 100 > state.value) {
                if (this.player) {
                    this.player.destroy();
                }
                var factory = this._builder.build([]);
                if (state.parametric) {
                    factory = this._builder.build([
                        style(typeof state.calcParametric == 'function' ? state.calcParametric(l_currentValue && l_currentValue > state.value ? state.value / l_currentValue : 1) : (state.style ? this._buildParametricStyle(state.style, l_currentValue > state.value ? 1 - l_currentValue / 100 : 1) : {})),
                        animate(state.time ? state.time : '300ms ease-in', style(typeof state.calcParametric == 'function' ? state.calcParametric(percentageLeft && percentageLeft > state.value ? state.value / percentageLeft : 1) : (state.style ? this._buildParametricStyle(state.style, percentageLeft > state.value ? 1 - percentageLeft / 100 : 1) : {})))
                    ]);
                }
                else {
                }
                this.player = factory.create(nativeElement, {});
                this.player.play();
            }
            else {
                if (this.player) {
                    this.player.destroy();
                }
                var factory = this._builder.build([]);
                if (state.parametric) {
                    factory = this._builder.build([
                        style(typeof state.calcParametric == 'function' ? state.calcParametric(1) : (state.style ? this._buildParametricStyle(state.style, l_currentValue > state.value ? 1 - l_currentValue / 100 : 1) : {})),
                        animate(state.time ? state.time : '30ms ease-in', style(typeof state.calcParametric == 'function' ? state.calcParametric(1) : (state.style ? this._buildParametricStyle(state.style, percentageLeft > state.value ? 1 - percentageLeft / 100 : 1) : {})))
                    ]);
                }
                else {
                }
                this.player = factory.create(nativeElement, {});
                this.player.play();
            }
        }
        return l_state;
    };
    AnimateScrollDirective.prototype._animateFromPercent = function (state) {
        //how much left in percentage of window height before top of element reaches viewpoint
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.innerHeight : window.innerHeight);
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            while (offsetElement) {
                elementOffsetTop += offsetElement.offsetTop;
                offsetElement = offsetElement.offsetParent;
            }
            var pxLeftUntilTopViewpoint = elementOffsetTop - scrollTop;
            var percentageLeft = pxLeftUntilTopViewpoint / windowHeight * 100;
            var l_state = this._setElementState(state.value, percentageLeft, state);
            if (this.player) {
                this.player.destroy();
            }
            var factory = this._builder.build([
                style({ width: '*' }),
                animate('350ms cubic-bezier(.35, 0, .25, 1)', style({ width: this.options.currentValue + '%' }))
            ]);
            this.player = factory.create(this.el.nativeElement, {});
            this.player.play();
            return l_state;
        }
        return false;
    };
    AnimateScrollDirective.prototype._pxElement = function (state) {
        //amount of element scrolled from bottom up in px
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement : window).innerHeight;
            var viewpoint = windowHeight + scrollTop;
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            while (offsetElement) {
                elementOffsetTop += offsetElement.offsetTop;
                offsetElement = offsetElement.offsetParent;
            }
            var breakpoint = elementOffsetTop + state.value;
            return this._setElementState(viewpoint, breakpoint, state);
        }
        return false;
    };
    AnimateScrollDirective.prototype._percentElement = function (state) {
        //amount of element scrolled from bottom up in percent
        if (this._isCurrentScreenSize(state.sizes)) {
            var nativeElement = this.el.nativeElement;
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.innerHeight : window.innerHeight);
            var offsetElement = nativeElement;
            var elementOffsetTop = 0;
            var viewpoint = windowHeight + scrollTop;
            var elementHeight = nativeElement.offsetHeight;
            while (offsetElement) {
                elementOffsetTop += offsetElement.offsetTop;
                offsetElement = offsetElement.offsetParent;
            }
            var pxOfElementScrolled = viewpoint - elementOffsetTop;
            var percentageOfElementScrolled = pxOfElementScrolled / elementHeight * 100;
            return this._setElementState(percentageOfElementScrolled, state.value, state);
        }
        return false;
    };
    AnimateScrollDirective.prototype._pxTotal = function (state) {
        //amount of page scrolled in px
        if (this._isCurrentScreenSize(state.sizes)) {
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            return this._setElementState(scrollTop, state.value, state);
        }
        return false;
    };
    AnimateScrollDirective.prototype._percentTotal = function (state) {
        //amount of page scrolled in percent
        if (this._isCurrentScreenSize(state.sizes)) {
            var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
            var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.innerHeight : window.innerHeight);
            var bodyHeight = document.documentElement.scrollHeight;
            var percentageScrolled = scrollTop / (bodyHeight - windowHeight) * 100;
            return this._setElementState(percentageScrolled, state.value, state);
        }
        return false;
    };
    AnimateScrollDirective.prototype._default = function (state) {
        //default state in case that no other states match
        if (typeof (state.method) !== 'undefined' && state.method === 'default') {
            //default state for specific size provided
            if (this._isCurrentScreenSize(state.sizes)) {
                return this._setElementState(1, 0, state);
            }
        }
        return false;
    };
    AnimateScrollDirective.prototype._emitOutput = function (state) {
        this.output.emit({
            state: state,
            options: this.options,
            elementRef: this.el
        });
    };
    AnimateScrollDirective.prototype._emitOutputStats = function (state, hasToBeBiggerThan, hasToBeSmallerThan) {
        var currentValue = null;
        if (state.method !== 'default') {
            currentValue = hasToBeBiggerThan;
            if (state.method === 'animateToPercent') {
                currentValue = hasToBeSmallerThan;
            }
            if (state.method === 'pxLeft') {
                currentValue = hasToBeSmallerThan + state.value - hasToBeBiggerThan;
            }
            if (state.method === 'pxElement') {
                currentValue = hasToBeBiggerThan - hasToBeSmallerThan + state.value;
            }
        }
        // console.log(currentValue, state, hasToBeBiggerThan, hasToBeSmallerThan);
        this.outputStats.emit({
            scrollTop: (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset),
            state: state,
            currentValue: currentValue,
            options: this.options,
            elementRef: this.el
        });
    };
    AnimateScrollDirective.prototype._setClass = function (stateClass) {
        if (typeof (stateClass) !== 'undefined' && this.classNameSetByAnimateScroll !== stateClass) {
            //class is provided and has to be applied to the element
            if (this.classNameSetByAnimateScroll !== '') {
                this.el.nativeElement.className = this.el.nativeElement.className.replace(this.classNameSetByAnimateScroll, stateClass);
            }
            else {
                this.renderer.setElementClass(this.el.nativeElement, stateClass, true);
            }
            this.classNameSetByAnimateScroll = stateClass;
        }
        else {
            //no class set for current state, remove class if one is set
            if (this.classNameSetByAnimateScroll !== '') {
                this.el.nativeElement.className = this.el.nativeElement.className.replace(this.classNameSetByAnimateScroll, '');
            }
            this.classNameSetByAnimateScroll = '';
        }
    };
    AnimateScrollDirective.prototype._setElementState = function (hasToBeBiggerThan, hasToBeSmallerThan, state) {
        var scrollTop = (this.animateBox ? this.animateBox.element.nativeElement.scrollTop : window.pageYOffset);
        var offsetElement = this.el.nativeElement;
        var elementOffsetTop = 0;
        var windowHeight = (this.animateBox ? this.animateBox.element.nativeElement.innerHeight : window.innerHeight);
        var bodyHeight = document.documentElement.scrollHeight;
        while (offsetElement) {
            elementOffsetTop += offsetElement.offsetTop;
            offsetElement = offsetElement.offsetParent;
        }
        this._emitOutputStats(state, hasToBeBiggerThan, hasToBeSmallerThan);
        if (state.setAtLastChance && scrollTop + windowHeight >= bodyHeight - state.setAtLastChanceBottomPx) {
            //element is default distance before bottom view end -> show element
            if (this.options.currentState !== state.state) {
                this.options.currentState = state.state;
                this._setClass(state.class);
                this._emitOutput(state);
            }
            return true;
        }
        else if (state.setAtLastChance && (scrollTop + state.setAtLastChanceTopPx) > elementOffsetTop) {
            //element is default distance before top view end -> show element
            if (this.options.currentState !== state.state) {
                this.options.currentState = state.state;
                this._setClass(state.class);
                this._emitOutput(state);
            }
            return true;
        }
        else if (hasToBeBiggerThan > hasToBeSmallerThan) {
            if (this.options.currentState !== state.state) {
                this.options.currentState = state.state;
                this._setClass(state.class);
                this._emitOutput(state);
            }
            return true;
        }
        else {
            return false;
        }
    };
    AnimateScrollDirective.prototype._isCurrentScreenSize = function (screenSizes) {
        //screenSizes is something like sm-up / lg-down
        if (screenSizes === 'all') {
            return true;
        }
        var currentScreenSize = this._getScreenSize();
        var size = screenSizes.split('-')[0];
        var direction = screenSizes.split('-')[1];
        var possibleScreenSizes = ['xs', 'sm', 'md', 'lg', 'xl'];
        var positionInPossibleScreenSizesArray = -1;
        for (var i = 0; i < possibleScreenSizes.length; i++) {
            if (possibleScreenSizes[i] === size) {
                positionInPossibleScreenSizesArray = i;
                i = possibleScreenSizes.length;
            }
        }
        if (positionInPossibleScreenSizesArray === -1) {
            //invalid screen size provided -> use all screen sizes
            console.warn('AnimateScroll:', 'Invalid screen sizes provided:', screenSizes);
            return true;
        }
        if (direction === 'up') {
            possibleScreenSizes = possibleScreenSizes.slice(positionInPossibleScreenSizesArray);
        }
        else if (direction === 'down') {
            possibleScreenSizes = possibleScreenSizes.slice(0, positionInPossibleScreenSizesArray + 1);
        }
        else {
            //invalid direction provided -> use all screen sizes
            console.warn('AnimateScroll:', 'Invalid screen sizes provided:', screenSizes);
            return true;
        }
        if (possibleScreenSizes.indexOf(currentScreenSize) !== -1) {
            return true;
        }
        return false;
    };
    AnimateScrollDirective.prototype._getScreenSize = function () {
        var screenSize = 'xs';
        var windowWidth = (this.animateBox ? this.animateBox.element.nativeElement.clientWidth : window.innerWidth);
        switch (true) {
            case (windowWidth >= 1200):
                screenSize = 'xl';
                break;
            case (windowWidth >= 992):
                screenSize = 'lg';
                break;
            case (windowWidth >= 768):
                screenSize = 'md';
                break;
            case (windowWidth >= 544):
                screenSize = 'sm';
                break;
        }
        ;
        return screenSize;
    };
    AnimateScrollDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[animatescroll]' /*,
                    animations: [
                        trigger(
                        'flyInOut',[
                
                            state('for', style({
                                left: '{{left_indent}}', // use interpolation
                            }), {params: {left_indent: 0}}), // default parameters values required
                
                            transition('* => for', [
                                animate(2000, keyframes([
                                    style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
                                    style({ opacity: 1, transform: 'translateX(-300px)', offset: 0.5 }),
                                ]))
                            ]),
                        ]
                        ),
                        trigger('animateScrollState', [
                                'animateToPercent',[
                                    state('inactive', style({
                                        backgroundColor: '#eee',
                                        transform: 'scale(1)'
                                    })),
                                    state('active',   style({
                                        backgroundColor: '#cfd8dc',
                                        transform: 'scale(1.1)'
                                    })),
                                    transition('inactive => active', animate('100ms ease-in')),
                                    transition('active => inactive', animate('100ms ease-out'))
                                ]
                        ])
                    ]*/
                },] },
    ];
    /** @nocollapse */
    AnimateScrollDirective.ctorParameters = function () { return [
        { type: ElementRef, decorators: [{ type: Inject, args: [forwardRef(function () { return ElementRef; }),] },] },
        { type: Renderer, decorators: [{ type: Inject, args: [forwardRef(function () { return Renderer; }),] },] },
        { type: AnimateScrollService, decorators: [{ type: Inject, args: [forwardRef(function () { return AnimateScrollService; }),] },] },
        { type: AnimateBoxDirective, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(function () { return AnimateBoxDirective; }),] },] },
        { type: AnimationBuilder, },
    ]; };
    AnimateScrollDirective.propDecorators = {
        'options': [{ type: Input, args: ['animatescroll',] },],
        'output': [{ type: Output, args: ['animatescroll',] },],
        'outputStats': [{ type: Output, args: ['animatescrollAll',] },],
    };
    return AnimateScrollDirective;
}());
export { AnimateScrollDirective };
//# sourceMappingURL=ng2-animate-scroll.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-scroll.directive.js
// module id = ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-scroll.directive.js
// module chunks = vendor